export default "/images/952ba85b36ace382e1d3671feed7b124.avif";